import React from "react";

import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bem } from "@react-md/utils";
import { Button as AntDButton } from "antd";
// eslint-disable-next-line no-restricted-imports
import { ButtonProps } from "antd/es/button";
import cn from "classnames";

const block = bem("mmc-float-button");

export interface FloatButtonProps extends Pick<ButtonProps, "disabled" | "icon" | "onClick"> {
  className?: string;
  type?: "primary" | "secondary";
}

const FloatButton = ({ className, type = "primary", ...props }: FloatButtonProps) => {
  return (
    <AntDButton
      className={cn(block({ [type]: true }), className)}
      icon={<FontAwesomeIcon icon={faPlus} size="xl" />}
      shape="round"
      type="primary"
      {...props}
    />
  );
};

export default FloatButton;
